import { Flex } from "@chakra-ui/react";
import { AgChartsReact } from "ag-charts-react";
import { AgChartProps } from "ag-charts-react/dist/types/src/agChartsReact";

export const MaybernChart: React.FC<AgChartProps> = (props) => (
  <Flex
    flex={1}
    minWidth="0"
    height="100%"
    justify="center"
    sx={{
      "div[data-ag-charts]": {
        width: "100%",
      },
    }}
  >
    <AgChartsReact {...props} />
  </Flex>
);
